/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect } from 'react'
// 业务层
import Web3, { Web3ReactProvider, getLibrary } from './web3'
import Web3Method from './web3/methods'
import System from './system'
import Scroll from './scroll'

function debug(): void {}

const Store: React.FC = ({ children }) => {
  useEffect(() => {
    console.log(`global contexts have been re-rendered at: ${Date.now()}`)

    debug()

    setTimeout(() => {
      debug()
    }, 1000)
  }, [])

  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3.Provider>
        <Web3Method.Provider>
          <System.Provider>
            <Scroll.Provider>{children}</Scroll.Provider>
          </System.Provider>
        </Web3Method.Provider>
      </Web3.Provider>
    </Web3ReactProvider>
  )
}

export default Store
